import React from "react";


export default class About extends React.Component {

  getExperienceYears() {
    const startDate = new Date(2020, 4); // May 2020 (month is 0-based)
    const currentDate = new Date();

    const diffInMs = currentDate - startDate;
    const diffInYears = diffInMs / (1000 * 60 * 60 * 24 * 365.25);

    return Math.floor(diffInYears);
  }

  render() {
    const experienceYears = this.getExperienceYears();

    return (
      <div className="about">
        <div>Dear visitor,</div>

        <div>
          As a passionate and dedicated software engineer, I am committed to building
          scalable, high-quality web applications with{" "}
          <strong>{experienceYears}+ years</strong> of hands-on experience in the MERN stack.

          <br /><br />

          I currently work on enterprise-scale platforms such as <strong>Marcel.ai</strong>, where I
          contribute to data-driven and cloud-integrated solutions using{" "}
          <strong>Azure Data Factory (ADF), Databricks, Service Bus</strong>, and distributed system
          integrations. My work involves collaborating with cross-functional teams, handling
          complex workflows, and delivering production-ready features in fast-paced environments.

          <br /><br />

          Previously, I worked as a <strong>Full Stack Developer at Flexsin Technology</strong>, where I
          built end-to-end solutions, strengthened my foundation in scalable application design,
          and gained hands-on experience in agile, collaborative teams.

          <br /><br />

          I bring a strong sense of ownership, a problem-solving mindset, and a continuous learning
          attitude to every project. I enjoy working at the intersection of engineering,
          performance, and usability—building software that is reliable, maintainable, and impactful.
        </div>
      </div>
    );
  }
}
